import Vue from 'vue'
import App from './App.vue'
// import Vconsole from 'vconsole'
import axios from '../../service/self_axios'
import Utils from '../../common/utils'
import VueVideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'
require('../../common/wxShare.js')
Vue.use(VueVideoPlayer)
// let vConsole = new Vconsole()
Vue.config.productionTip = false
Vue.prototype.$isClient = navigator.userAgent.match(/cfbondClient/gi)
Vue.prototype.$axios = axios.http
Vue.prototype.$ifLogin = axios.ifLogin
Vue.prototype.Utils = Utils
Vue.prototype.videoId = Utils.getQueryString('video_id')


new Vue({
  render: h => h(App),
}).$mount('#app')
